import { FC } from 'react';
import { cn } from '@new/lib';

interface CalendarLegendItemProps {
  label: string;
  colorClass: string;
}

export const CalendarLegendItem: FC<CalendarLegendItemProps> = ({ label, colorClass }) => {
  return (
    <div className="flex items-center gap-1">
      <div className={cn('w-4 h-4 rounded border-2', colorClass)} />
      <span className="font-semibold">{label}</span>
    </div>
  );
};
